/**
 * Form manager module for handling form state and submissions
 */
class InventorFormManager {
    constructor() {
        this.validator = new InventorFormValidator(document.getElementById('inventor-form'));
        this.pdfGenerator = new InventorFormPDF();
        this.api = new InventorFormAPI();
        this.ui = new InventorFormUI();
        
        this.setupEventListeners();
    }

    /**
     * Sets up event listeners for both forms
     */
    setupEventListeners() {
        const inventorForm = document.getElementById('inventor-form');
        const mndaForm = document.querySelector('.mnda-form');

        if (inventorForm) {
            inventorForm.addEventListener('submit', (e) => {
                e.preventDefault();
                this.handleInventorFormSubmit();
            });
        }

        if (mndaForm) {
            mndaForm.addEventListener('submit', (e) => {
                e.preventDefault();
                this.handleMNDAFormSubmit(mndaForm);
            });
        }

        this.ui.setupNavigation();
    }

    /**
     * Handles the inventor form submission
     */
    async handleInventorFormSubmit() {
        if (this.validator.validateForm()) {
            const formData = this.validator.collectFormData();
            this.ui.fillMNDAForm(formData);
            this.ui.switchForms(true);
        }
    }

    /**
     * Handles the MNDA form submission
     * @param {HTMLFormElement} mndaForm - The MNDA form element
     */
    async handleMNDAFormSubmit(mndaForm) {
        const submitButton = mndaForm.querySelector('.btn-mnda');
        this.ui.updateSubmitButtonState(submitButton, true);

        try {
            const formData = this.validator.collectMNDAFormData();
            
            // Generate and upload PDF
            const mndaPdfUrl = await this.pdfGenerator.generateAndUploadPDF(formData);
            formData.mndaPdf = mndaPdfUrl;

            // Submit form data
            await this.api.submitInventorRegistration(formData);
            
            // Show success message
            this.ui.showSuccessBanner();
        } catch (error) {
            console.error('Form submission error:', error);
            this.ui.showError('There was an error submitting the form. Please try again.');
        } finally {
            this.ui.updateSubmitButtonState(submitButton, false);
        }
    }
}

// Export for use in other modules
window.InventorFormManager = InventorFormManager;
